module.exports = __webpack_public_path__ + "static/fonts/Fact-CompressedBlack.c940980.eot";